import axios from 'axios';

import { cfg } from '../config/config';
import { SignInReq, SignInRes } from '../entity/auth';

export const login = (data: SignInReq) =>
  axios.post<SignInRes>(`${cfg.apiUrl}/login`, data);
